import React from "react"
import { AppLink } from "@ecom/ui/components/AppLink"

export const variantConfig = {
  abTest: [
    {
      question: <>Халва – кредитная или&nbsp;дебетовая&nbsp;карта?</>,
      answer:
        "Халва – универсальная карта, которую можно использовать одновременно как дебетовую и карту рассрочки*. Сменить режим можно легко в приложении «Халва – Совкомбанк»",
    },
    {
      question: <>Какой минимальный и&nbsp;максимальный лимит рассрочки*?</>,
      answer: (
        <>
          Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000
          руб.
        </>
      ),
    },
    {
      question: "Влияет ли наличие карты на кредитную нагрузку?",
      answer:
        "Поскольку с помощью Халвы вы покупаете товары в рассрочку*, наличие задолженности по карте влияет на кредитную нагрузку. Банк будет относиться к вам более лояльно, если вы будете активно пользоваться картой и своевременно вносить платежи",
    },
    {
      question: (
        <>
          Насколько надежен банк, который выпускает карту? <br className="d-none d-large-block" />
          Где о нем можно узнать информацию?
        </>
      ),
      answer: (
        <>
          <p>
            Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
            рейтинги финансовой организации — собрана на{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/about/info"
            >
              отдельной странице
            </AppLink>
          </p>
          <br />
          <p>
            Совкомбанк зарекомендовал себя как надежная организация и не раз лидировал в народных
            рейтингах:
          </p>
          <ul>
            <li>
              в 2018 году «Халву»{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
              >
                признали
              </AppLink>
              лучшей банковской картой года, лауреат премии «Финансовая элита России»;
            </li>
            <li>
              по итогам 2024 года банк{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://www.banki.ru/services/responses/?date=2024"
              >
                возглавил
              </AppLink>{" "}
              «Народный рейтинг» портала «
              <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
                Банки.ру
              </AppLink>
              », а до 2022{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
              >
                занимал
              </AppLink>{" "}
              в нем первое место четыре года подряд;
            </li>
            <li>
              в 2024 году Совкомбанк первый в{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://www.sravni.ru/banki/rating/karty/"
              >
                рейтинге
              </AppLink>{" "}
              кредитных карт России по версии «
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://www.sravni.ru"
              >
                Сравни»
              </AppLink>{" "}
              (⭑4.91/5.00).
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Что такое подписка «Халва.Десятка»?",
      answer: (
        <>
          <p>Это платная услуга, с которой вы получаете дополнительные преимущества:</p>
          <ul>
            <li>
              <strong>10 месяцев рассрочки* на покупки. </strong>Единый увеличенный срок рассрочки*
              в&nbsp;260&nbsp;000{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://halvacard.ru/shops/special"
              >
                магазинах-партнёрах
              </AppLink>{" "}
              Халвы*;
            </li>
            <li>
              <strong>
                Удвоение{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://scb.ru/document?id=2777"
                >
                  кэшбэка
                </AppLink>
                .
              </strong>{" "}
              В 2 раза больше кэшбэка за каждую покупку или поездку на Яндекс GO – возвращайте до
              10% от стоимости;
            </li>
            <li>
              <strong>+5% к ставке вкладов.</strong> Увеличение** на +5% по вкладам на сроке 36
              мес., +2% на сроке 24 мес. (+1% на других сроках) при ежемесячном выполнении условия:
              от 10 покупок по Халве на общую сумму от 20 000 ₽.***;
            </li>{" "}
            <li>
              <strong>+1% к ставке Онлайн-копилки.</strong> Увеличение на +1% базовой ставки по
              счету**** при ежемесячном выполнении условия: от 10 покупок по Халве на общую сумму от
              20 000 ₽***
            </li>{" "}
            <li>
              <strong>+1 месяц рассрочки*.</strong> На снятия, переводы и покупки заёмными
              средствами не у партнеров;
            </li>{" "}
            <li>
              <strong>Бесплатный стикер Рау.</strong> Для удобной оплаты телефоном и повышенного
              кэшбэка;
            </li>
            <li>
              <strong>Комплексная IT-защита.</strong> Онлайн-консультация эксперта при
              неисправностях и сбоях в работе компьютера или смартфона;
            </li>
            <li>
              <strong>Помощник по покупкам.</strong> Личный консультант подберет для вас нужный
              товар с лучшей ценой и сроком рассрочки*;
            </li>
            <li>
              <strong>Страхование жизни и здоровья. </strong> Выплаты при несчастном случае или
              болезни;
            </li>
            <li>
              <strong>Страхование покупок.</strong> Возмещение при повреждении или поломке важных
              покупок, а также юридическая помощь по правам покупателей;
            </li>
          </ul>
          <p>
            * Если базовый срок рассрочки* партнёра превышает 10 месяцев, то к покупке применяется
            базовый срок.
          </p>
          <p>
            ** Ставка повышается в конце срока и начисляется на общую сумму вкладов в банке до 1,5
            млн ₽.
          </p>
          <p>
            *** Или платежей в разделе «Оплата услуг» в приложении «Халва – Совкомбанк», или
            переводов / операций по снятию заемных средств. Для карт «Социальная Халва» от 10 000 ₽.
          </p>
          <p>
            **** Увеличенная базовая ставка начисляется на сумму до 1,5 млн руб. с 4-го месяца, если
            это ваша первая Копилка, а также с 1-го месяца по повторно открытым Копилкам
          </p>
        </>
      ),
    },
    {
      question: <>Сколько времени рассматривают заявку на&nbsp;Халву?</>,
      answer:
        "Вы получите решение через несколько минут после того, как отправите заявку. В редких случаях на это может потребоваться 1 рабочий день.",
    },
  ],
}
